export const OPEN_SIDEBAR = 'OPEN_SIDEBAR';
export const CLOSE_SIDEBAR = 'CLOSE_SIDEBAR';
export const SET_CONTENT_LOCALE = 'SET_CONTENT_LOCALE';

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

export const STORE_RESTAURANT_TYPES = 'STORE_RESTAURANT_TYPES';
export const STORE_RESTAURANT_TYPE = 'STORE_RESTAURANT_TYPE';
export const DELETE_RESTAURANT_TYPE = 'DELETE_RESTAURANT_TYPE';
export const RESTORE_RESTAURANT_TYPE = 'RESTORE_RESTAURANT_TYPE';

export const STORE_RESTAURANTS = 'STORE_RESTAURANTS';
export const STORE_RESTAURANT = 'STORE_RESTAURANT';
export const DELETE_RESTAURANT = 'DELETE_RESTAURANT';
export const RESTORE_RESTAURANT = 'RESTORE_RESTAURANT';

export const STORE_ALL_BRANCHES = 'STORE_ALL_BRANCHES';
export const STORE_BRANCHES = 'STORE_BRANCHES';
export const STORE_BRANCH = 'STORE_BRANCH';
export const DELETE_BRANCH = 'DELETE_BRANCH';
export const RESTORE_BRANCH = 'RESTORE_BRANCH';
export const STORE_BRANCH_NAMES = 'STORE_BRANC_NAMES';

export const STORE_CONTACT_INFO_TYPES = 'STORE_CONTACT_INFO_TYPES';

export const STORE_TAGS = 'STORE_TAGS';
export const STORE_TAG = 'STORE_TAG';
export const DELETE_TAG = 'DELETE_TAG';

export const STORE_CATEGORYIES = 'STORE_CATEGORYIES';
export const STORE_CATEGORY = 'STORE_CATEGORY';
export const DELETE_CATEGORY = 'DELETE_CATEGORY';
//export const RESTORE_CATEGORY = 'RESTORE_CATEGORY';

export const STORE_COMPANY_VALUES = 'STORE_COMPANY_VALUES';
export const STORE_ONE_COMPANY_VALUE = 'STORE_ONE_COMPANY_VALUE';
export const DELETE_COMPANY_VALUE = 'DELETE_COMPANY_VALUE';

export const STORE_PRODUCTS = 'STORE_PRODUCTS';
export const STORE_ONE_PRODUCT = 'STORE_ONE_PRODUCT';
//export const STORE_ONE_FOOD_IN_ORDER = 'STORE_ONE_FOOD_IN_ORDER';
export const DELETE_ONE_PRODUCT = 'DELETE_ONE_PRODUCT';
export const PRODUCT_STATUS = 'PRODUCT_STATUS';
// export const REMOVE_ONE_PRODUCT = 'REMOVE_ONE_PRODUCT';
// export const RESTORE_ONE_FOOD = 'RESTORE_ONE_FOOD';

export const SET_PAID = 'PAID';
export const STATUS = 'STATUS';

export const SET_STATUS = 'SET_STATUS';
export const CANCEL = 'CANCEL';

export const STORE_NEWS = 'STORE_NEWS';
export const STORE_ONE_NEWS = 'STORE_ONE_NEWS';
export const DELETE_ONE_NEWS = 'DELETE_ONE_NEWS';
export const RESTORE_ONE_NEWS = 'RESTORE_ONE_NEWS';

export const STORE_SLIDER = 'STORE_SLIDER';
export const STORE_ONE_SLIDER = 'STORE_ONE_SLIDER';
export const DELETE_SLIDER = 'DELETE_SLIDER';

export const STORE_USERS = 'STORE_USERS';
export const STORE_ONE_USER = 'STORE_ONE_USER';
export const TOGGLE_USER = 'TOGGLE_USER';

export const STORE_ORDERS = 'STORE_ORDERS';
export const STORE_ORDERS_BY_BRANCH = 'STORE_ORDERS_BY_BRANCH';
export const STORE_ONE_ORDER = 'STORE_ONE_ORDER';
export const DELETE_ONE_ORDER = 'DELETE_ONE_ORDER';

export const STORE_ROLES = 'STORE_ROLES';
export const STORE_ONE_ROLE = 'STORE_ONE_ROLE';
export const DELETE_ROLE = 'DELETE_ROLE';
export const STORE_PERMISSIONS = 'STORE_PERMISSIONS';

export const STORE_ADMINS = 'STORE_ADMINS';
export const STORE_ONE_ADMIN = 'STORE_ONE_ADMIN';
export const DELETE_ADMIN = 'DELETE_ADMIN';

export const STORE_ALL_NOTIFICATIONS = 'STORE_ALL_NOTIFICATIONS';
export const MARK_NOTIFICATION_AS_READ = 'MARK_NOTIFICATION_AS_READ';
export const MARK_ALL_NOTIFICATIOSN_AS_READ = 'MARK_ALL_NOTIFICATIOSN_AS_READ';
export const STORE_NOTIFICATIONS_COUNT = 'STORE_NOTIFICATIONS_COUNT';

export const STORE_STATISTICS = 'STORE_STATISTICS';

export const STORE_COMMENTS = 'STORE_COMMENTS';
export const DELETE_ONE_COMMENT = 'DELETE_ONE_COMMENT';

export const STORE_NOTIFICATION_TEMPLATES = 'STORE_NOTIFICATION_TEMPLATES';

export const STORE_CUSTOM_PAGES = 'STORE_CUSTOM_PAGES';
export const STORE_CUSTOM_PAGE = 'STORE_CUSTOM_PAGE';
export const DELETE_CUSTOM_PAGE = 'DELETE_CUSTOM_PAGE';
export const RESTORE_CUSTOM_PAGE = 'RESTORE_CUSTOM_PAGE';

export const STORE_REVIEWS = 'STORE_REVIEWS';

export const STORE_TABLES = 'STORE_TABLES';
export const STORE_ONE_TABLE = 'STORE_ONE_TABLE';
export const DELETE_ONE_TABLE = 'DELETE_ONE_TABLE';
export const STORE_SCHEDULE = 'STORE_SCHEDULE';

export const STORE_RESERVATIONS = 'STORE_RESERVATIONS';
export const STORE_ONE_RESERVATION = 'STORE_ONE_RESERVATION';
export const DELETE_ONE_RESERVATION = 'DELETE_ONE_RESERVATION';
export const ACCEPT_RESERVATION = 'ACCEPT_RESERVATION';
export const REJECT_RESERVATION = 'REJECT_RESERVATION';

export const STORE_OFFERS = 'STORE_OFFERS';
export const STORE_ONE_OFFER = 'STORE_ONE_OFFER';
export const DELETE_ONE_OFFER = 'DELETE_ONE_OFFER';

export const STORE_BRANCH_INFO = 'STORE_BRANCH_INFO';
export const STORE_ONE_BRANCH_INFO = 'STORE_ONE_BRANCH_INFO'; 
export const DELETE_BRANCH_INFO = 'DELETE_BRANCH_INFO'; 

export const STORE_COUPONS = 'STORE_COUPONS';
export const STORE_ONE_COUPON = 'STORE_ONE_COUPON';
export const DELETE_ONE_COUPON = 'DELETE_ONE_COUPON';
export const SET_ACTIVE = 'SET_ACTIVE';